import { useLocale } from "@react-aria/i18n";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";
import { Bell, CalendarDays, Clock, User } from "lucide-react";

import { AppointmentRescheduling } from "./appointment-rescheduling";
import { getCurrentAppointmentQueryOptions } from "../api/queries";

const LAST_STEP = 2;

export function RescheduleBookingPage() {
    const { date: dateParam, slot: slotParam, appointment_id: appointmentId, step = "1" } = useSearch({ from: "/(dashboard)/dashboard/weight-loss/appointments/reschedule-booking" });

    const { locale } = useLocale();

    const appointmentReschedule = useSuspenseQuery(getCurrentAppointmentQueryOptions(appointmentId))

    const currentAppointmentDetail = appointmentReschedule?.data

    const successUrl = `${window.location.origin}/dashboard/weight-loss/appointments/confirm-reschedule`;
    const errorUrl = `${window.location.origin}/dashboard/weight-loss/appointments/error`;

    const pageStep = Number(step);
    const currentStep = isNaN(pageStep) ? 1 : Math.max(Math.min(LAST_STEP, pageStep), 1)


    if (!currentAppointmentDetail || !appointmentId) {
        return null
    }

    return (
        <div className="flex flex-col w-full sm:px-2 lg:20 md:flex-row gap-4">
            {currentStep === 1 && (
                <div className="mb-8 w-full md:w-[30%]">
                    <div className="flex flex-col bg-white border divide-y-2 border-[#E6E6E6] shadow-sm rounded-xl gap-2">
                        <h2 className="font-medium text-xl text-center p-2">Weight loss consultation</h2>

                        <div className="flex flex-col gap-2 p-4 space-y-4">
                            <h3 className="text-lg font-medium">Current Booking Details</h3>
                            <div className="flex items-center text-[#202020CC] text-base gap-2">
                                <User className="size-4" />
                                <span>{currentAppointmentDetail?.appointment?.name}</span>
                            </div>
                            <div className="flex items-center text-[#202020CC] text-base gap-2">
                                <CalendarDays className="size-4" />
                                <span>{new Date(currentAppointmentDetail?.appointment.meeting_utc_datetime as string).toLocaleDateString(locale, {
                                    weekday: 'long',
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })}</span>
                            </div>
                            <div className="flex items-center text-[#202020CC] text-base gap-2">
                                <Bell className="size-4" />
                                <span> {new Date(currentAppointmentDetail?.appointment.meeting_utc_datetime as string).toLocaleString(locale, {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                })}
                                    {", "}
                                    {Intl.DateTimeFormat().resolvedOptions().timeZone.replace(/_/g, " ").split("(")[0]?.trim()}
                                </span>
                            </div>
                            <div className="flex items-center text-[#202020CC] text-base gap-2">
                                <Clock className="size-4" />
                                <span>{currentAppointmentDetail?.appointment?.zoom_metadata?.duration} Minutes</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className={currentStep === 1 ? "w-full md:w-[70%]" : "w-full"}>
                <AppointmentRescheduling
                    step={currentStep}
                    appointmentId={appointmentId}
                    selectedDate={dateParam}
                    selectedSlot={slotParam}
                    to="/dashboard/weight-loss/appointments/reschedule-booking"
                    successUrl={successUrl}
                    errorUrl={errorUrl}
                />
            </div>
        </div>
    )
}
